<ng-container>
  <app-panel-header #panelHeaderComponent [@fade]="StateAnimation.IN" *ngIf="canShowInit" (onRefreshClick)="refreshDashBoard()"></app-panel-header>
  <div class="row" style="padding-left: 30px; padding-top: 25px;">
    <mat-progress-bar mode="indeterminate" *ngIf="loadingUltimaDataProcessamento$ | async"></mat-progress-bar>
    <span
      class="h6 text-muted float-left mt-1 btn-refresh">Última data processamento: {{dataUltimoProcessamento$ | async | date: 'dd/MM/yyyy'}}</span>
  </div>
  <app-cards #cardsComponent [@fade]="StateAnimation.IN" *ngIf="canShowInit" (onCardSelected)="setCard($event)"></app-cards>

  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.NENHUM"></div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.CARTEIRAS_PROCESSADAS">
    <app-processada *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-processada>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.CARTEIRAS_NAO_PROCESSADAS">
    <app-nao-processada *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-nao-processada>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.ENQUADRADA">
    <app-enquadrada *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-enquadrada>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.DESENQUADRADA">
    <app-desenquadrada *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-desenquadrada>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.COM_REGRAS">
    <app-com-regra *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-com-regra>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.SEM_REGRAS">
    <app-sem-regra *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-sem-regra>
  </div>
  <div [@fade]="StateAnimation.IN" (@fade.done)="animationDone($event)" *ngIf="cardTypeSelected === CardType.CANCELADO">
    <app-cancelada *ngIf="canShow" [pageCadastroVO]="pageCadastroVO" (afterViewInit)="setPageCadastroVO($event)"></app-cancelada>
  </div>
</ng-container>
